import { render, staticRenderFns } from "./LanguageBox.vue?vue&type=template&id=ae790646&scoped=true&"
import script from "./LanguageBox.vue?vue&type=script&lang=js&"
export * from "./LanguageBox.vue?vue&type=script&lang=js&"
import style0 from "./LanguageBox.vue?vue&type=style&index=0&id=ae790646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae790646",
  null
  
)

export default component.exports